import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { CustomState } from "@tggstore/Store/Reducers";
import { useSelector } from "react-redux";

export function useCartTracking() {
    return useSelector((state: CustomState) => {
        const cartState = getCurrentCartState(state);
        const session = state.context.session;
        const cartLines = cartState.value?.cartLines;
        const currency = session?.currency?.currencyCode || "";
        const billToCustomerName = getBillToState(state, cartState.value?.billToId)?.value?.customerNumber ?? "";
        const transactionType = state.customTransactionType.transactionType || "";

        return {
            cartLines,
            currency,
            billToCustomerName,
            affiliation: state.customDefaultWarehouse.warehouse?.description || "",
            orderSubTotal: cartState.value?.orderSubTotal || 0,
            shipping: cartState.value?.shippingAndHandling || 0,
            tax: cartState.value?.totalTax || 0,
            transactionType,
        };
    });
}
